import { api as i } from "../utils/configuration.js";
import { crudService as r } from "../js/request-zRag5cDd.js";
const a = {
  search: (e, t) => r.get(i.UNITS_URL, { params: e, signal: t }),
  findById: ([e, t = !1], U) => r.get(`${i.UNITS_URL}/${e}`, { params: { withNearbySchools: t }, signal: U }),
  findByIdWithToken: ([e, t], U) => r.get(`${i.UNITS_URL}/${e}`, {
    headers: { Authorization: `Bearer ${t}` },
    signal: U
  }),
  getRentedUnit: (e) => r.get(`${i.UNITS_URL}/rented-units`, { signal: e }),
  getCities: (e) => r.get(`${i.UNITS_URL}/cities`, { signal: e })
};
export {
  a as UnitService
};
//# sourceMappingURL=units.js.map
